<section class="modal-content modal-content-right">
  <button
    cjButton
    aria-label="Close invoice_closemodal_button"
    class="modal-close"
    tabIndex="-1"
    (click)="close()"
  >
    <cj-icon icon="times" pack="font-awesome-solid"></cj-icon>
  </button>

  <section class="flex flex-column">
    <div class="header-content mx-6 pt-6">
      <h5>Provide Invoice Note</h5>
    </div>

    <div class="body-content py-8 px-6">
      <cj-form-field class="flex-grow-1 w-full">
        <cj-form-label>Invoice Notes / Description</cj-form-label>
        <textarea
          cjInput
          fullWidth
          required
          type="text"
          id="notesInfo"
          rows="6"
          class="invoice_notes_text"
          placeholder="Add Notes"
          placeholder="Add Notes Here"
          [disabled]="isLoading"
          [status]="isSubmitted && !notesInfo ? 'danger' : ''"
          [(ngModel)]="notesInfo"
        ></textarea>
      </cj-form-field>
    </div>

    <div class="footer-content flex justify-end gap-2.5 mx-6 pb-6">
      <button
        cjButton
        outline
        size="large"
        [disabled]="isLoading"
        class="invoice_closemodal_button"
        (click)="close()"
      >
        Cancel
      </button>
      <button
        cjButton
        type="submit"
        size="large"
        class="invoice_savenotes_button"
        [disabled]="isLoading"
        (click)="saveNotes()"
      >
        <span *ngIf="isLoading" class="mr-2">
          <cj-icon
            class="fa-spin"
            icon="spinner"
            pack="font-awesome-solid"
          ></cj-icon>
        </span>
        {{ !isLoading ? "Save" : "Saving..." }}
      </button>
    </div>
  </section>
</section>
